module.exports = __webpack_public_path__ + "static/media/riskDiabetes.ec8d9793.mp3";